import {SeatCheckoutGatewayBase} from "./SeatCheckoutGatewayBase";

import {BaseCheckout} from "../BaseCheckout/BaseCheckout";

export class PlaceholderPaymentGateway extends SeatCheckoutGatewayBase {
    CheckoutContent = BaseCheckout;
}
